module.exports = __webpack_public_path__ + "static/img/bg_education.1db8e0d0.jpg";